// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lanturn: PokeData = {
  "id": 171,
  "name": "lanturn",
  "height": 12,
  "weight": 225,
  "base_experience": 161,
  "types": [
    PokeType.WATER,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "take-down",
    "supersonic",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "thunder-wave",
    "confuse-ray",
    "bubble",
    "flail",
    "spark",
    "stockpile",
    "spit-up",
    "swallow",
    "charge",
    "signal-beam",
    "aqua-ring",
    "discharge",
    "electro-ball",
    "ion-deluge",
    "eerie-impulse",
    "spotlight"
  ],
  "moves": [
    "supersonic",
    "hydro-pump",
    "bubble-beam",
    "confuse-ray",
    "bubble",
    "thunder",
    "thunder-shock",
    "liquidation",
    "quick-tempo",
    "electric-terrain",
    "thunder-fang",
    "electric-wrath",
    "wild-charge"
  ],
  "evolution_chain": {
    "id": 86,
    "item": null,
    "species": [
      {
        "name": "chinchou",
        "order": 201,
        "types": [
          PokeType.WATER,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lanturn",
        "order": 202,
        "types": [
          PokeType.WATER,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 170,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 27,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 161,
    "speed": 112,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
